import React, { Component } from "react";
import PaymentsDropdown from "./PaymentsDropdown";

export default class PaymentsDesktop extends Component {
  checkPayments = () => {
    const { payments } = this.props;
    if (!payments.length) {
      return true;
    } else {
      return false;
    }
  };
  render() {
    const {
      walletPay,
      payments,
      onSelectPayment,
      onClickNewCard,
      selectedPayment
    } = this.props;

    return (
      (walletPay && (
        <div className="eWallet d-flex align-items-center">
          <span>
            <i className="icon icon-wallet" />
          </span>
          <p>Local E Wallet</p>
        </div>
      )) ||
      ((this.checkPayments() && (
        <div
          className="addPayment d-flex align-items-center cursor-pointer"
          onClick={onClickNewCard}
        >
          <p>+</p>
          <span>
            <p>Add new card</p>
          </span>
        </div>
      )) || (
        <PaymentsDropdown
          selectedPayment={selectedPayment}
          onSelectItem={onSelectPayment}
          payments={payments}
          onClickNewCard={onClickNewCard}
        />
      ))
    );
  }
}
